/* From https://css-tricks.com/password-strength-meter/  */

import styled from 'styled-components';
import colors from 'material-colors';

const color0 = colors.grey[200];
const color1 = colors.red[500];
const color2 = colors.orange[500];
const color3 = colors.lime[500];
const color4 = colors.green[500];

const Meter = styled.meter`

  /* Reset the default appearance */
  /*-webkit-appearance: none;*/
  /*-moz-appearance: none;*/
  /*appearance: none;*/

  /* Applicable only to Firefox */
  background: none;
  background-color: ${color0};

  &::-webkit-meter-bar {
    background: none;
    background-color: ${color0};
  }

  /* Webkit based browsers */
  &[value="1"]::-webkit-meter-optimum-value { background: ${color1}; }
  &[value="2"]::-webkit-meter-optimum-value { background: ${color2}; }
  &[value="3"]::-webkit-meter-optimum-value { background: ${color3}; }
  &[value="4"]::-webkit-meter-optimum-value { background: ${color4}; }

  /* Gecko based browsers */
  &[value="1"]::-moz-meter-bar { background: ${color1}; }
  &[value="2"]::-moz-meter-bar { background: ${color2}; }
  &[value="3"]::-moz-meter-bar { background: ${color3}; }
  &[value="4"]::-moz-meter-bar { background: ${color4}; }
`;

export default Meter;
